
 import CourseReducer from './CourseReducer'
 import ProjectReducer from './ProjectReducer'
 import CBTExamReducer from './CBTExamReducer'
import { combineReducers } from 'redux'


 const allReducers=combineReducers({
    courses:CourseReducer,
    Project:ProjectReducer,
    cbtExam: CBTExamReducer
  
})


export default allReducers;  